import { FeatureSelector, MapMouseEvent } from "mapbox-gl";
import { ControlsProps, LocationProps, HoveredLocationProps } from "@/utils/types";
import { MAP_INTERACTIVE_LAYER_IDS, MapParamsProps } from "./constants";
import { getSourceId } from "./selectors";

/* Gets the closest interactive feature to mousevent */
export function getEventFeature(event: MapMouseEvent) {
	const features = event.target?.queryRenderedFeatures(event.point);
	const feature = features && features.find(f =>
		f.layer?.id && MAP_INTERACTIVE_LAYER_IDS.includes(f.layer?.id)
	);
	return feature;
}
/* Create feature selector */
export const getFeatureSelector = (
	params: ControlsProps,
	location: LocationProps | HoveredLocationProps
) => {
	const id = location?.id;
	const source = getSourceId({
		...params,
	} as MapParamsProps)
	const sourceLayer = source;
	const featureSelector = { id, source, sourceLayer };
	return (id && source && sourceLayer ? featureSelector : {}) as FeatureSelector;
};